import React from 'react'
import styles from './FeedModal.module.css';
import useFetch from '../../Hooks/useFetch';
import Error from '../Helper/Error';
import Loading from '../Helper/Loading';
import PhotoContent from '../Photo/PhotoContent';
import { PHOTO_GET } from '../../api';
const FeedModal = ({photo, setModalPhoto}) => {
  const {data, error, loading, request} = useFetch();
  React.useEffect(() => {
    const {url, options} = PHOTO_GET(photo.id);
    request(url, options);
  },[photo, request]);
  function closeModal(event){
    if(event.target === event.currentTarget) setModalPhoto(null);
  }
  return (
    <div className={styles.modal} onClick={closeModal}>
      {error && <Error error={error}/>}
      {loading && <Loading />}
      {data && <PhotoContent data={data}/>}
    </div>
  )
}

export default FeedModal
